/**
 * @module ConfigConstants
 * @description Enumeration used for listing down constants associated with config.
 * @enum {string}
 * @readonly
 * @author Kelvin John Santos
 * @version 1.0
 * @since March 22, 2019
 */
export const CONFIG_MODULE = "configModule";
export const PLATFORM_CONFIG = "platformConfig";
export const SET_PLATFORM_CONFIG = "SET_PLATFORM_CONFIG";
export const GET_PLATFORM_CONFIG = "GET_PLATFORM_CONFIG";
export const CLEAR_PLATFORM_CONFIG = "CLEAR_PLATFORM_CONFIG";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const IS_LOADING = "getIsLoading";
export const IS_ENABLED_OTP = "enableOTPListerner";
